import { useMemo } from 'react';
import { Box } from '@mui/material';
import Chart from '../common/Chart';
import ChartProvider from '../../contexts/ChartContext';
import { asNamedSolutions, type ScreenSolution, type TimeSeries } from '../../types';
import { productionChartData } from '../../utils/chartOptions/solutionSeries';

type Props = {
  reference: TimeSeries | undefined;
  solutions: ScreenSolution[];
};

const ProductionChart = ({ reference, solutions }: Props) => {
  const data = useMemo(
    () => (solutions.length ? productionChartData(reference, asNamedSolutions(solutions)) : null),
    [reference, solutions],
  );

  return (
    <>
      <Box sx={{ justifyContent: 'center', pl: 1, pr: 1 }}>
        {reference && (
          <>
            <ChartProvider>
              <Box>
                <Chart data={data} />
              </Box>
            </ChartProvider>
          </>
        )}
      </Box>
    </>
  );
};

export default ProductionChart;
